<template>
  <div class="">
    <el-dialog :before-close="close" :visible.sync="visible" :title="``" :width="type == 1 ? '800px' : '100%'" append-to-body center>
      <div @click="close" class="dialog n-rela">
        <el-image class="dialog-image" :src="require('@/assets/img/home-blacklist.png')" fit="cover">
          <el-image class="dialog-image" slot="error" :src="require('@/assets/img/xianyouhe-logo.png')" fit="cover"></el-image>
        </el-image>
        <div class="dialog-box">
          <div :class="{ active: type == 2 }" class="dialog-name">该ID已被列入黑名单 · 请谨慎交易防止被骗</div>
          <div :class="{ active: type == 2 }" class="dialog-subname">*温馨提示：全网有奖征集骗子17位，上传骗子找回狗17位可获得{{ money || 0 }}元账户余额奖励！</div>
        </div>
        <div class="dialog-close">
          <i class="el-icon-circle-close"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DialogBlackList",
  props: {
    // 显示
    visible: {
      type: Boolean,
      default: false
    },
    // 
    type: {
      type: [String, Number],
      default: 0,
    },
    money: {
      type: [String, Number],
      default: 0,
    }
  },
  data () {
    return {

    };
  },
  computed: {
    ...mapState([""])
  },
  mounted () {

  },
  methods: {
    // 关闭弹框
    close () {
      this.$emit("close");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mobile.scss";

.dialog {
  cursor: pointer;

  &-image {
    width: 100%;
  }

  &-name {
    height: 86px;
    line-height: 86px;
    background-color: #2f3130;
    border-radius: 50px;
    font-size: 26px;
    font-weight: bold;
    color: #f0d8be;
    text-align: center;
    letter-spacing: 5px;

    &.active {
      height: 70px;
      line-height: 70px;
      font-size: 18px;
    }
  }

  &-subname {
    margin: 10px 0 0;
    font-size: 20px;
    color: #f0d8be;
    text-align: center;

    &.active {
      font-size: 14px;
    }
  }

  &-close {
    margin: 40px 0 0;
    font-size: 32px;
    color: #f0d8be;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

::v-deep .el-dialog {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  padding: 20px;
  background: transparent;

  .el-dialog__headerbtn {
    z-index: 1;
  }

  .el-icon-close {
    font-size: 22px;
    color: #FFF;
  }

  .el-dialog__body {
    padding: 0;
  }
}

// 进入动画
.dialog-fade-enter-active {
  animation: dialog-fade-in 1s;
}

// 离开动画
.dialog-fade-leave-active {
  animation: dialog-fade-out 1s;
}

@keyframes dialog-fade-in {
  0% {
    transform: scale(2);
    opacity: 0;
  }

  50% {
    transform: scale(2);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(2);
    opacity: 0;
  }

  100% {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
